import { useContext } from 'react';
import Cookies from 'js-cookie';
import { Modal } from 'react-bootstrap';
import { motion } from "framer-motion";
import { useNavigate } from 'react-router-dom';
import { StudyProgressContext } from '../../Context';
import StudyTwoProcedureConfig from '../../helpers/StudyTwoProcedureConfig';
import StudyProgressConfig from '../../helpers/StudyProgressBarConfig';

export default function StudyConfirmationModal ({ show, handleClose, handleConfirm, title, message, overWriteUrl, progressOverwrite }) {

    let url = '';
    const navigate = useNavigate();
    const { studyProgress, setStudyProgress } = useContext(StudyProgressContext);
    const studyProgressConfig = new StudyProgressConfig().getStudyTwoProcedureIndexToProgressMapping();
    
    const configHelper = new StudyTwoProcedureConfig();
    const config = configHelper.getProcedureMappingConfig();
    const cookieName = configHelper.get_tracking_cookie_name();
    const next_session_index = parseInt(Cookies.get(cookieName) || 0) + 1;
    
    url = overWriteUrl ? overWriteUrl : config[next_session_index];

    if(!url){
        title = "Congrads!"
        message = "You have finished Study Two! Thank you for paticipating in our research! Please feel free to explore our web app!"
        url = "/explore"
    }

    const handleConfirmFunction = (url) => {
        navigate(url);

        if(progressOverwrite){
            setStudyProgress(progressOverwrite);
        } else if (next_session_index && studyProgressConfig[next_session_index]){
            setStudyProgress(studyProgressConfig[next_session_index]);
        }
        
        if(handleConfirm){
            handleConfirm();
        }
    };
    
    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{message}</Modal.Body>
            <Modal.Footer>
                <motion.button 
                    type="button"
                    className="button"
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.8 }}
                    onClick={handleClose}
                >
                    Got it!
                </motion.button>
                {/* <motion.button 
                    type="button"
                    className="button button-danger"
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.8 }}
                    onClick={() => handleConfirmFunction(url)}
                >
                    Yes
                </motion.button> */}
            </Modal.Footer>
        </Modal>
    );
};